import React from 'react'

import CategoriesList from './categories/CategoriesList'
import ExecutionFormHandler from './_form/ExecutionFormHandler'

const DynamicForm = ({ children, replies, questions, onChange, autofillContext, ...props }) => {
  return (
    <ExecutionFormHandler
      questions={questions}
      replies={replies}
      onChange={onChange}
      autofillContext={autofillContext}
    >
      {children}
      <CategoriesList {...props} />
    </ExecutionFormHandler>
  )
}

export default DynamicForm
